// assets/fullpage-init.js
(function () {
  var BREAKPOINT = 768; // px
  var mql = window.matchMedia('(max-width: ' + BREAKPOINT + 'px)');
  var fpInstance = null;
  var SCRIPT_SRC = 'https://cdn.jsdelivr.net/npm/fullpage.js/dist/fullpage.min.js';
  var CSS_HREF  = 'https://cdn.jsdelivr.net/npm/fullpage.js/dist/fullpage.min.css';

  // --- Utilities ------------------------------------------------------------
  function loadScriptOnce(src, id, cb) {
    if (document.getElementById(id)) return cb && cb();
    var s = document.createElement('script');
    s.id = id;
    s.src = src;
    s.async = true;
    s.onload = function () { cb && cb(); };
    s.onerror = function () { console.warn('Failed to load script:', src); };
    document.head.appendChild(s);
  }

  function loadCssOnce(href, id) {
    if (document.getElementById(id)) return;
    var l = document.createElement('link');
    l.id = id;
    l.rel = 'stylesheet';
    l.href = href;
    document.head.appendChild(l);
  }

  function getFullpageCtor() {
    // fullPage can expose either window.fullpage or window.Fullpage depending on build
    return window.fullpage || window.Fullpage || null;
  }

  // --- Init / destroy logic -------------------------------------------------
  function initFullPage() {
    var Ctor = getFullpageCtor();
    if (!Ctor) {
      console.warn('fullpage.js constructor not found on window');
      return null;
    }

    return new Ctor('#fullpage', {
      // add your license key if you have one
      licenseKey: '63K88-S37U6-3PKH8-N0J28-YNSPP',
      afterLoad: function (origin, destination) {
        var header =
          document.querySelector('.section-header .header') ||
          document.querySelector('.header');
        if (!header) return;

        var el = destination.item;
        var isFooter =
          el.classList.contains('footer') ||
          destination.anchor === 'footer';

        header.classList.toggle('header--at-footer', !!isFooter);
      }
    });
  }

  function ensureState() {
    var isMobile = mql.matches;
    var container = document.querySelector('#fullpage');

    // No container on this template/section
    if (!container) {
      if (fpInstance) {
        try { fpInstance.destroy('all'); } catch (e) {}
        fpInstance = null;
      }
      return;
    }

    if (!isMobile && !fpInstance) {
      // Make sure library & CSS are present, then init
      loadCssOnce(CSS_HREF, 'fullpage-css');
      loadScriptOnce(SCRIPT_SRC, 'fullpage-js', function () {
        fpInstance = initFullPage();
      });
      return;
    }

    if (isMobile && fpInstance) {
      try { fpInstance.destroy('all'); } catch (e) {}
      fpInstance = null;
    }
  }

  // --- Boot + listeners -----------------------------------------------------
  // Initial run
  ensureState();

  // React to breakpoint changes (orientation/resize)
  if (mql.addEventListener) {
    mql.addEventListener('change', ensureState);
  } else if (mql.addListener) {
    // older Safari
    mql.addListener(ensureState);
  }

  // Optional: handle Shopify section re-renders (e.g., when customizing theme)
  document.addEventListener('shopify:section:load', ensureState);
  document.addEventListener('shopify:section:unload', ensureState);
})();
